import { createSlice } from "@reduxjs/toolkit";
import { StorageService } from "infra/storage";

const createInitialState = () => {
    const token = StorageService.getAuthToken;

    if (!token) return { status: false, user: null };

    return {
        status: true,
        user: {
            status: true,
            user: true,
            role: StorageService.getRole(),
        },
    };
};

const userValuesSlice = createSlice({
    name: "userValues",
    initialState: createInitialState(),
    reducers: {
        login: (state, _action) => {
            state.status = true;
            state.user = {
                username: true,
                email: true,
                token: StorageService.getAuthToken(),
                role: StorageService.getRole(),
            };
        },
        logout: (state) => {
            state.status = false;
            state.user = null;
            StorageService.clear();
        },
        clearStore: (_state) => {
            // Reset the state to initial values when clearing the store
        },
    },
});

export const { login, logout, clearStore } = userValuesSlice.actions;
export default userValuesSlice.reducer;
